import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';
import { OptionWithOptionalValue } from '../common';

export const SELECT_FIELD_ELEMENT_TYPE = 'selectfield' as const;
export const SelectFieldElementType = z.literal(SELECT_FIELD_ELEMENT_TYPE);

export const SelectFieldParamsSchema = FieldSchema.extend({
  optionNotFoundText: z.string().optional(),
  options: z.array(OptionWithOptionalValue),
});

export type TSelectFieldParams = z.infer<typeof SelectFieldParamsSchema>;

export const SelectFieldElementSchema = InitialUIElement.extend({
  element: SelectFieldElementType,
  params: SelectFieldParamsSchema,
});
